// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2Fvxp","buttons":"RemoveExpirationActionButtons_buttons__91n2m"};